import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IGetUnseenbadgeDto } from '@shared/model/badge/get-unseen-badge.model';
import { SharedModule } from "../../module/shared.module";
import { EImageType } from '@shared/pipes/image.pipe';
import { finalize, tap } from 'rxjs';
import { ChallengeAchievementService } from '@app/pages/challenges/services/challenge-achievement.service';
import { PickChallengeDialogComponent } from '../dialogs/pick-challenge-dialog/pick-challenge-dialog.component';
import { SnackBarTypes } from '../cutome-snack-bar/custome-snack-bar.component';
import { htmlUrls } from '@shared/utils/router-paths';
import { Router } from '@angular/router';
import { BadgeService } from '@shared/service/http_services/badge.service';
import { BaseComponent } from '../base/base.component';


@Component({
  selector: 'beh-badge-notifier-dialog',
  imports: [SharedModule],
  templateUrl: './badge-notifier-dialog.component.html',
  styleUrl: './badge-notifier-dialog.component.scss'
})

export class BadgeNotifierDialogComponent extends BaseComponent implements OnInit {
  data = inject<any>(MAT_DIALOG_DATA);
  private _dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<BadgeNotifierDialogComponent>>(MatDialogRef);
  private router = inject(Router);
  private challengeAchievementService = inject(ChallengeAchievementService);
  private badgeService = inject(BadgeService);

  routes = htmlUrls;
  imageType = EImageType;
  challenge: IGetUnseenbadgeDto | null = null;
  achievement: IGetUnseenbadgeDto | null = null;
  joinLoading = false;
  currentBadge!: currentBadgeEnum;
  currentBadgeEnum = currentBadgeEnum;
  readBooksCount!: string;
  seenBadgeIds: string[] = [];

  constructor() {
    super();
    this.dialogRef.beforeClosed().subscribe(() => {
      this.seenAllBadges();
    });
  }

  ngOnInit(): void {
    this.classifyBadgeItem();
  }

  classifyBadgeItem() {
    this.data.forEach((el: any) => {
      if (el.badge.key.startsWith('c')) {
        this.challenge = el;
      } else if (el.badge.key.startsWith('a')) {
        this.achievement = el,
          this.readBooksCount = el.assignedAchievement.key.match(/\d+/)?.[0];
      }
    })
    this.setBadgeState();
  }

  setBadgeState() {
    if (this.challenge) {
      this.currentBadge = currentBadgeEnum.challenge;
    } else if (this.achievement) {
      this.currentBadge = currentBadgeEnum.achievement;
    }
  }

  joinChallenge(id: string) {
    this.joinLoading = true;

    this.challengeAchievementService.pickChallengeWithDetail(id).pipe(
      tap(res => {
        if (!res?.hasError) {
          this._dialog.open(PickChallengeDialogComponent,
            {
              panelClass: 'pick-challenge-dialog',
              data: { challenge: res?.result }
            })
        }
        if (res?.error?.code === 409) {
          this.snackbarService.openSnackbar(SnackBarTypes.error, 'شما در چالش مشابه شرکت کرده‌اید.' );
        }
      }),
      finalize(() => {
        this.joinLoading = false;
        // this.closeDialog();
      })
    ).subscribe();
  }

  navigateToAllChallenges() {
    this.router.navigate([this.routes.challenges], { queryParams: { allChallenges: true } })
    this.closeDialog();
  }

  // markBadgeAsSeen(badgeId: string) {
  //   if (!this.seenBadgeIds.includes(badgeId)) {
  //     this.seenBadgeIds.push(badgeId);
  //   }
  // }

  acknowledge() {
    if (this.currentBadge === currentBadgeEnum.challenge && this.achievement) {
      this.currentBadge = currentBadgeEnum.achievement;
      // this.markBadgeAsSeen(this.achievement.badge.id);
    } else {
      this.closeDialog();
    }
  }

  allAchievment() {
    this.router.navigate([this.routes.challenges_achievements, this.currentUser?.id]);
    this.closeDialog();
  }

  seenAllBadges() {
    this.badgeService.seenAlluserBadge().subscribe();
  }

  closeDialog() {
    // this.badgeService.seenAlluserBadge().subscribe();
    this.dialogRef.close();
  }
}

enum currentBadgeEnum {
  challenge,
  achievement
}
